export default "__VITE_ASSET__HQ7QEKxX__"